module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.subheading) ? _c('p', {
    staticClass: "article-subheading"
  }, [_vm._v("\n  " + _vm._s(_vm.subheading) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25231138","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/fields/Subheading.vue
// module id = 1173
// module chunks = 23 25